import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import gql from "graphql-tag";

import ArrowUpSvg from "../../svg/arrow-up.svg";
import ArrowDownSvg from "../../svg/arrow-down.svg";
import NoIconSvg from "../../svg/no-icon.svg";

export interface IIcon {
  id: string;
  name: string;
  sortKey: string;
  svg: {
    bucket: string;
    region: string;
    key: string;
  };
  description: string;
  advancedOnly: boolean;
  hideForFibo: boolean;
}

// First, create the thunk
export const fetchIcons = createAsyncThunk("icons/list", async () => {
  const response = await API.graphql(
    graphqlOperation(gql`
      query {
        listIcons(limit: 500) {
          items {
            id
            name
            sortKey
            svg {
              bucket
              region
              key
            }
            description
            advancedOnly
            hideForFibo
          }
        }
      }
    `)
  );
  return response as GraphQLResult<{ listIcons: { items: IIcon[] } }>;
});

// Then, handle actions in your reducers:
const icons = createSlice({
  name: "icons",
  initialState: { entities: [] as IIcon[] },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchIcons.fulfilled, (state, payload) => {
      const icons = payload.payload.data?.listIcons.items;

      if (icons)
        state.entities = icons.sort((iconA, iconB) => {
          if (!iconA || !iconB) {
            return 0;
          }

          const aIdx = parseInt(iconA.sortKey, 10);
          const bIdx = parseInt(iconB.sortKey, 10);

          if (!Number.isNaN(aIdx) && !Number.isNaN(bIdx)) {
            return aIdx - bIdx;
          }

          return iconA.sortKey.localeCompare(iconB.sortKey);
        });

      return state;
    });
    builder.addCase(fetchIcons.rejected, (state, payload) => {
      console.error("rejected!", payload.error);
    });
  },
});

export const iconUrl = (iconId: string) => {
  switch (iconId) {
    case "arrowUp":
      return ArrowUpSvg;
    case "arrowDown":
      return ArrowDownSvg;
    case "":
      return NoIconSvg;
  }

  return `https://engravings.basalte.world/public/${iconId}.svg?hacks`;
};

export default icons;
